import React from 'react'
import Home from '../Home/home';
import Navbar from '../Navbar/navbar';
import About from '../About/about';
import Projects from '../Projects/projects';
import Skills from '../Skills/skills';
import Contact from '../Contact/contact';

export default function main() {
  return (
    <div>
      <Navbar/>
      <Home/>
      <About/>
      <Skills/>
      <Projects/>
      <Contact/>
    </div>
  )
}
